import store from "@/store"
import IMSAPI from "@/services/api"

export const login = ({ username, password }) => {
  return IMSAPI.post("/auth/login", {
    username,
    password
  })
}

export const logout = () => {
  return IMSAPI.get("/auth/logout")
}

export const refreshToken = () => {
  const refreshToken = store.getters.getRefreshToken
  return IMSAPI.post("/auth/token", {
    refreshToken
  })
}

export default {
  login,
  logout,
  refreshToken
}
